import React from 'react';
import styled from 'styled-components';
import { SectionName } from '../common/styles';
import { BaseDesc } from './styles';

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${props => (props.theme.isMobile ? 54 : 83)}px;
  width: 100vw;
`;

const Title = styled(SectionName)`
  color: ${props => props.theme.bodyColor};
`;

const Desc = styled(BaseDesc)`
  position: relative;
  max-width: unset;
  margin-top: 27px;
  text-align: center;
  ${props => (props.theme.isMobile ? `
    margin: 27px 20px 0 20px;
  ` : `
    width: 788px;
  `)};
`;

export default function Reason() {
  return (
    <Container id="why">
      <Title>Why work with Livewire?</Title>
      <Desc>
        Livewire is Australia&apos;s fastest-growing investment platform with more than
        250,000 investors and advisers now accessing it each month. Every day, Livewire
        showcases investment ideas and strategies from hundreds of Australia&apos;s most
        credible fund managers and investment professionals.
      </Desc>
    </Container>
  );
}
